import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

// Aviso antes de salir a Mercado Pago desde una videollamada.
//
// Mercado Pago no se puede embeber (Checkout Pro es un redirect, sin modo
// modal), así que pagar con MP abre otra pestaña. Lo que sí podemos hacer es
// contarle al comprador qué va a pasar —la llamada sigue en esta pestaña y
// tiene que volver a ella cuando termine— antes de abrir el link. `live`: lo
// mismo desde el vivo.
const LeaveForMercadoPagoDialog = ({ open, storeName, live = false, onClose, onConfirm }) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Vas a ir a Mercado Pago</DialogTitle>
        <DialogContent>
            <Typography color="text.secondary" sx={{ mb: 1.5 }}>
                El pago se hace en el sitio de Mercado Pago, en una pestaña
                nueva.{' '}
                {live
                    ? 'El vivo sigue en esta pestaña: cuando termines, volvé acá y seguís mirándolo. Tu pedido queda en Mis órdenes.'
                    : 'La videollamada sigue abierta en esta pestaña: cuando termines, volvé acá y seguís donde estabas.'}
            </Typography>
            {!live && (
                <Typography color="text.secondary">
                    {storeName || 'La tienda'} te va a esperar.
                </Typography>
            )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, flexDirection: 'column', gap: 1 }}>
            <Button
                fullWidth
                variant="contained"
                onClick={onConfirm}
                sx={{
                    backgroundColor: '#00a650',
                    '&:hover': { backgroundColor: '#008f45' },
                }}
            >
                Ir a Mercado Pago
            </Button>
            <Button fullWidth variant="outlined" onClick={onClose} sx={{ ml: '0 !important' }}>
                Ahora no
            </Button>
        </DialogActions>
    </Dialog>
);

export default LeaveForMercadoPagoDialog;
